import React, {useEffect, useReducer} from "react";
import {DatePicker} from "@material-ui/pickers";
import {Grid, IconButton, withStyles} from "@material-ui/core";
import classNames from "classnames";
import {withFb} from "../../contexts/FbProvider";
import {withApontamento} from "../../contexts/ApontamentoProvider";
import localforage from "../../utils/localforage";
import moment from "moment";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import Button from '@material-ui/core/Button';
import {style} from './style';
import reducer from '../../utils/defaultReducer';

const initialState = {
    selectedDate: moment(),
    filterDates: [],
    saldoHoras: {horasPorDia: 8},
    hollydays: [],
    ferias: []
}

function MainCalendar(props) {

    const [state, setState] = useReducer(reducer, initialState,() => initialState);

    useEffect(() => {
        (async () => {
            setState({
                filterDates: props.data.filterDates(await localforage.getItem('horas-mes')),
                saldoHoras: await localforage.getItem('saldo-horas') ?? {horasPorDia: 8},
                hollydays: await localforage.getItem('hollydays'),
                ferias: await localforage.getItem('ferias'),
                saldoHorasDia: await localforage.getItem('saldo-horas-dia'),
            })
        })()
    }, [])

    const handleDateChange = (date) => {
        setState({
            selectedDate: date,
        });
    };

    const renderWrappedWeekDay = (date, selectedDate, dayInCurrentMonth) => {
        const {classes} = props;
        const horasPorDia = state.saldoHoras?.horasPorDia || 8;

        const selected = date.isSame(selectedDate, "day");
        const today = date.isSame(moment(), "day");
        let day = date.format('YYYY-MM-DD');
        let dayStyle = classes.day;
        let hours = props.data.getObjTimePerDay(state.filterDates, day)?.horaNormal;

        const isHollyday = state.hollydays?.some(hd => moment(hd?.dtFeriado).isSame(day, 'day'));
        const hollydayData = getFeriado(day);
        const isFerias = state.ferias?.some(hd => moment(hd?.data).isSame(day, 'day'));        
        const feriasDia = getFerias(day);
        
        if (hours || isHollyday || isFerias) {
            if (hours === horasPorDia) {
                dayStyle = classes.equal;
            } else if (hours > horasPorDia) {
                dayStyle = classes.high;
            } else if (hours < horasPorDia && !isHollyday && !isFerias) {
                dayStyle = classes.low;
            } else if (isHollyday) {
                dayStyle = classes.hollyday
            } else if (isFerias){
                dayStyle = classes.ferias                            
            }
        }

        const dayClassName = classNames(dayStyle, classes.day, {
            [classes.highlight]: selected,
            [classes.today]: today,
            [classes.nonCurrentMonthDay]: !dayInCurrentMonth,
            [classes.border]: selected && dayStyle !== classes.day,
        });

        return (
            <div>
                <IconButton className={dayClassName} alt={hollydayData?.descricao || feriasDia?.data} title={hollydayData?.descricao || feriasDia?.data}>
                    <span> {date.format("D")} </span>
                    {
                        hollydayData &&
                        <Typography variant={'caption'} className={classes.feriadoLabel}>Feriado</Typography>
                        ||
                        feriasDia &&
                        <Typography variant={'caption'} className={classes.feriasLabel}>Férias</Typography>
                       }
                </IconButton>
            </div>
        );
    };

    const horasApontadas = () => {
        const horasPorDia = state.saldoHoras?.horasPorDia || 8;
        const coeficient = 100 / horasPorDia;
        let horaDia; 
        if (ferias){
            horaDia = horasFerias * coeficient;
        } else {
             horaDia = props.data.getObjTimePerDay(state.filterDates, state.selectedDate.format('YYYY-MM-DD'))?.horaNormal * coeficient;
        }    
        if (isNaN(horaDia))
            return 0
        return horaDia > 100 ? 100 : horaDia;
    }

    const handleNewApontamento = () => {
        const onSuccess = () => {
            props.apontamentos.addPendencyDialog({onSuccess}).then(() => {
                setTimeout(async () => setState({
                    filterDates: props.data.filterDates(await localforage.getItem('horas-mes'))
                }), 2000)
            });
        }
        localforage.getItem('liderado').then(ld => {
            var ops = {
                data: state.selectedDate,
                onSuccess};
            if(ld){
                ops = {...ops, nomeLiderado: ld.nomeLiderado}
            } 
            props.apontamentos.addPendencyDialog(ops).then()
        });
    }

    const getFeriado = (day) => {
        return state.hollydays?.filter(hd => moment(hd.dtFeriado).isSame(day, 'day'))?.[0];
    }
    const getFerias = (day) => {
        return state.ferias?.filter(hd => moment(hd.data).isSame(day, 'day'))?.[0];
    }
   
    const {classes} = props;
    const horaDia = props.data.getTimePerDay(state.filterDates, state.selectedDate.format('YYYY-MM-DD')) ?? 0;
    const objHoraDia = props.data.getObjTimePerDay(state.filterDates, state.selectedDate.format('YYYY-MM-DD')) ?? {};
    const horasNO = `${objHoraDia?.horaNormal ? `(NO = ${parseFloat(objHoraDia.horaNormal.toFixed(2))} h)` : ''}`
    const horasPL = `${objHoraDia?.horaPl ? ` (PL = ${parseFloat(objHoraDia.horaPl.toFixed(2))} h)` : ''}`
    const horasPT = `${objHoraDia?.horaPt ? ` (PT = ${parseFloat(objHoraDia.horaPt.toFixed(2))} h)` : ''}`

    const feriado = getFeriado(state.selectedDate)?.descricao.toLowerCase();
    const ferias = getFerias(state.selectedDate);
    const horasFerias = parseInt(getFerias(state.selectedDate)?.qtdHoras);
    
    return (
        <Grid container justifyContent={"flex-start"} direction={"column"} className={classes.picker}>
            <DatePicker
                autoOk
                orientation="vertical"
                variant="static"
                openTo="date"
                disableToolbar={false}
                className={classes.basePicker}
                value={state.selectedDate}
                renderDay={renderWrappedWeekDay}
                onChange={handleDateChange}
            />
                <Grid className={classes.progressBar}>
                <Typography>total: {ferias? ferias.qtdHoras : parseFloat(horaDia.toFixed(2))} h</Typography>
                <LinearProgress variant="determinate" value={horasApontadas()}/>
                <Typography variant={'subtitle2'}> {horasNO} {horasPL} {horasPT}</Typography>
                {
                    feriado && <Typography variant={'caption'}
                                           style={{textTransform: 'capitalize'}}>Feriado: {feriado}</Typography>
                                           ||
                                           ferias &&  <Typography variant={'caption'}
                                           style={{textTransform: 'capitalize'}}>Férias</Typography>                        
                }
            </Grid>
                      
            <Grid container justifyContent={'center'}>
                <Button variant={'outlined'} onClick={handleNewApontamento} disabled={ferias? true : false} >Fazer Apontamento</Button>
            </Grid>
            <Grid className={classes.legendCalendar}>
                <hr/>
                <div className={classes.divLegend}><button className={classes.yellowCircle}></button><span> Apontamento com horas excedente</span></div><br></br>
                <div className={classes.divLegend}><button className={classes.greenCircle}></button><span> Apontamento com horas normais</span></div><br></br>
                <div className={classes.divLegend}><button className={classes.redCircle}></button><span> Apontamento com horas faltantes</span></div><br></br>
                <div className={classes.divLegend}><button className={classes.blueCircle}></button><span> Dia selecionado</span></div><br></br>
                <div className={classes.divLegend}><button className={classes.whiteCircle}></button><span> Dia sem apontamento</span></div><br></br>
                <div className={classes.divLegend}><button className={classes.purpleCircle}></button><span> Feriado</span></div><br></br>
                <div className={classes.divLegend}><button className={classes.darkPurpleCircle}></button><span> Férias</span></div><br></br>
            </Grid>
        </Grid>
    )
}

export default withStyles(style)(withFb(withApontamento(MainCalendar)))
